import { Modal } from "react-bootstrap";
// import "./deletemodal.css";

const DeleteModal = ({ show, shows, handleClose, title, handledelete, handleDelete, postId }) => {
  const isVisible = show !== undefined ? show : shows;
  const deleteAction = handledelete || handleDelete;

  return (
    <>
      <Modal
        show={!!isVisible}
        animation={true}
        onHide={handleClose}
        className="mt-5 pt-5"
      >
        <Modal.Body className="col-8 mx-auto text-center p-t-3 pb-3">
          <h5 className="mt-4">Are You Sure You Want to Delete Your {title}</h5>
        </Modal.Body>
        <div className="d-flex justify-content-center pb-4">
          <button className="post-btn" onClick={handleClose}>
            Cancel
          </button>
          <button
            className="ms-3 cancle-btn cursor"
            onClick={() => deleteAction && deleteAction(postId)}
          >
            Delete
          </button>
        </div>
      </Modal>
    </>
  );
};

export default DeleteModal;
